import { Dispositivos } from '../enums/disposivios.enum';
import { TablasDispositivos } from '../enums/tablas-dispositivos.enum';

export interface ConfiguracionDispositivo {
  id: Dispositivos;
  tabla: TablasDispositivos;
  tablaTipo: string;
  tablaModelo: string;
  tipoField: string;
  modeloField: string;
  detalleRuta: string;
}

export const CONFIGURACION_DISPOSITIVOS: Record<
  Dispositivos,
  ConfiguracionDispositivo
> = {
  [Dispositivos.Computadoras]: {
    id: Dispositivos.Computadoras,
    tabla: TablasDispositivos.Computer,
    tablaTipo: 'ComputerType',
    tablaModelo: 'ComputerModel',
    tipoField: 'computertypes_id',
    modeloField: 'computermodels_id',
    detalleRuta: 'COMPUTADORA',
  },
  [Dispositivos.DispositivosRed]: {
    id: Dispositivos.DispositivosRed,
    tabla: TablasDispositivos.NetworkEquipment,
    tablaTipo: 'NetworkequipmentType',
    tablaModelo: 'NetworkequipmentModel',
    tipoField: 'networkequipmenttypes_id',
    modeloField: 'networkequipmentmodels_id',
    detalleRuta: 'DISP. RED',
  },
  [Dispositivos.Impresoras]: {
    id: Dispositivos.Impresoras,
    tabla: TablasDispositivos.Printer,
    tablaTipo: 'PrinterType',
    tablaModelo: 'PrinterModel',
    tipoField: 'printertypes_id',
    modeloField: 'printermodels_id',
    detalleRuta: 'IMPRESORA',
  },
  [Dispositivos.Monitores]: {
    id: Dispositivos.Monitores,
    tabla: TablasDispositivos.Monitor,
    tablaTipo: 'MonitorType',
    tablaModelo: 'MonitorModel',
    tipoField: 'monitortypes_id',
    modeloField: 'monitormodels_id',
    detalleRuta: 'MONITOR',
  },
  [Dispositivos.Dispositivos]: {
    id: Dispositivos.Dispositivos,
    tabla: TablasDispositivos.Peripheral,
    tablaTipo: 'PeripheralType',
    tablaModelo: 'PeripheralModel',
    tipoField: 'peripheraltypes_id',
    modeloField: 'printermodels_id',
    detalleRuta: 'PERIFERICO',
  },
  RACKS: {
    id: Dispositivos.Racks,
    tabla: TablasDispositivos.Rack,
    tablaTipo: 'RackType',
    tablaModelo: 'RackModel',
    tipoField: 'racktypes_id',
    modeloField: 'rackmodels_id',
    detalleRuta: 'RACK',
  },
  [Dispositivos.Telefonos]: {
    id: Dispositivos.Telefonos,
    tabla: TablasDispositivos.Phone,
    tablaTipo: 'PhoneType',
    tablaModelo: 'PhoneModel',
    tipoField: 'phonetypes_id',
    modeloField: 'phonemodels_id',
    detalleRuta: 'TELEFONO',
  },
};
